import { SegmentEvent } from '../../enum/segment/segment-event.enum';

export class MarketClosedWarningEvent {
    constructor(
        public type: SegmentEvent,
        public events: {
            duration: number,
            canceled: boolean,
        },
    ) {}
}